import React, { useEffect, useState } from 'react'
import Http from '../../../Common/Http';
import ReactDataTable from '../../../Common/ReactDataTable';
import { Link } from 'react-router-dom';
import IsLogin from '../../../Common/IsLogin';

const Set = () => {
    const [receivedData, setReceivedData] = useState([]);
    const [loading, setLoading] = useState(false);

    // Fetch data from /planning API
    const fetchData = async () => {
        setLoading(true);
        try {
            const res = await Http.get("/sets");
            setReceivedData(res.data);
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setLoading(false);
        }
    };

    const cols = [
        { field: "code", header: "Receipt No" },
        { field: "name", header: "Name" },
        { field: "work_order_receipt_no", header: "Work order" },
        { field: "department_art_name", header: "Department art" },
        {
            field: (rowData) => (
                <Link
                    to={`/set-details/${rowData.id}`}
                    className="btn btn-info btn-sm"
                    title="set-details"
                >
                    <i className="fa fa-list" aria-hidden="true"></i>
                </Link>
            ),
            header: "Action",
        }
    ]

    useEffect(() => {
        fetchData();
    }, []);
    return (
        <div>
            <IsLogin />
            <div className="am-mainpanel">
                <div className="am-pagetitle">
                    <h5 className="am-title">All Set</h5>

                    <Link to="/create-sets" className="btn btn-primary" title="Add Work Plan">
                        <i className="fa fa-plus-square mg-r-6"></i>Add New Sets
                    </Link>

                </div>
                <div className="am-pagebody">
                    <div className="card pd-20 pd-sm-40">
                        <ReactDataTable
                            cols={cols}
                            receiveData={receivedData}
                            isLoading={loading}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Set
